import { Deviation } from './coachAnalysis';

/**
 * 센터 평균 대비 편차 막대 — 강사 현황의 「지표 펼치기」 블록에 쓰던 그 막대.
 *
 * ─────────────────────────────────────────────────────────────
 * 왜 파일로 뺐나
 * ─────────────────────────────────────────────────────────────
 * 강사 데이터 드로어(CoachDataDrawer)가 **같은 지표 비교**를 보여줘야 합니다.
 * 거기서 막대를 새로 그리면 같은 강사의 같은 지표가 두 화면에서 다르게 보입니다 —
 * 옛 CoachDetailDrawer 를 지운 이유가 그것이었습니다.
 *
 * 이 파일은 그리기만 합니다. 값(`Deviation`)은 전부 `coachAnalysis.analyzeCoach`
 * 가 만든 것을 그대로 받습니다. 여기서 다시 계산하지 않습니다.
 *
 * 평균을 0으로 놓고 좌우로 뻗는 막대입니다.
 * "58.3%"만 보면 좋은지 모르지만, 가운데 선에서 오른쪽으로 뻗으면 설명이 필요 없습니다.
 */
const CoachDeviationBar = ({ d }: { d: Deviation }) => {
    const good = d.score > 0;
    // ±100%를 화면 절반으로 잡는다. 그 이상은 끝에 붙인다.
    const width = Math.min(Math.abs(d.score), 1) * 50;
    const color = d.kind === 'STRENGTH' ? '#00A793' : d.kind === 'WEAKNESS' ? '#FF5A64' : '#C4CCD8';

    return (
        <div className="flex items-center" style={{ gap: 10 }}>
            <span style={{ fontSize: 12.5, color: '#5B6B7F', width: 118, flex: 'none', textAlign: 'right' }}>
                {d.metric.label}
            </span>
            <div style={{ flex: 1, position: 'relative', height: 20 }}>
                <span
                    style={{
                        position: 'absolute', left: '50%', top: 0, bottom: 0,
                        width: 1, background: '#DDE5F0',
                    }}
                />
                <span
                    style={{
                        position: 'absolute',
                        left: good ? '50%' : `${50 - width}%`,
                        width: `${width}%`,
                        top: 4, height: 12,
                        background: color,
                        borderRadius: 3,
                        minWidth: 2,
                    }}
                />
            </div>
            {d.detail && (
                <span style={{ fontSize: 11.5, color: '#7C8794', flex: 'none', whiteSpace: 'nowrap' }}>{d.detail} ·</span>
            )}
            <span
                style={{
                    fontSize: 13.5, fontWeight: 700, width: 62, flex: 'none', textAlign: 'right',
                    color: d.kind === 'NEUTRAL' ? '#7C8794' : color,
                }}
            >
                {d.value}
                <span style={{ fontSize: 11, fontWeight: 500 }}>{d.metric.unit}</span>
            </span>
            <span style={{ fontSize: 11.5, color: '#A7B0BC', width: 74, flex: 'none' }}>
                평균 {d.avg}
                {d.metric.unit}
            </span>
        </div>
    );
};

export default CoachDeviationBar;
